export interface IKeyValuePair<K, V> {
    Key: K;
    Value: V;
    Type: string;
}

export class KeyValuePairArray<K, V> extends Array<KeyValuePair<K, V>>   {

    constructor(...items: KeyValuePair<K, V>[]) {
        super(...items);
        Object.setPrototypeOf(this, KeyValuePairArray.prototype);
    }

    Mock() {
        return new KeyValuePairArray<K, V>();
    }

}

export class KeyValuePair<K, V> implements IKeyValuePair<K, V> {

    Key: K;
    Value: V;
    Type: string;

    constructor(key: K = null, value: V = null, type: string = '') {
        this.Key = key;
        this.Value = value;
        this.Type = type;
    }
}
